import { api } from "../api";

const maintenanceExportById = async (
    token: string,
    id: number,
    type: string,
    simpleXlsxExport: boolean
) => {
    return api.get(
        `/maintenances/${id}/${type}/export`,
        {
            params: {
                simpleXlsxExport,
            },
            responseType: "arraybuffer",
            headers: {
                Authorization:
                    `Bearer ${token}`,
            },
        }
    );
};

export default maintenanceExportById;